import { escapeRegExp, sortBy } from 'lodash-es'

export type LocationOption = {
  id: number
  label: string
  searchText: string
}

type Location = {
  id: number
  name?: string | null
}

export const toLocationOptions = (locations: Location[]): LocationOption[] =>
  sortBy(
    locations.map(l => ({ id: l.id, name: l.name || '' })),
    ['name', 'id'],
  ).map(l => {
    const label = `${l.id}: ${l.name}`

    return { id: l.id, label, searchText: label.toLowerCase() }
  })

// Each search term must match the start of a word, so "swiss re" matches "Swiss Re London" but not "Centre".
export const toWordPrefixPatterns = (text: string): RegExp[] =>
  text
    .toLowerCase()
    .split(/\s+/)
    .filter(Boolean)
    .map(term => new RegExp(`(^|[^\\p{L}\\p{N}])${escapeRegExp(term)}`, 'u'))
